<div class="w-full px-4 sm:px-6 lg:px-8 pt-1.5 pb-1 sm:pt-4 bg-white" *ngIf="isStandalone">
  <app-breadcrum [data]="garageBreadcrumbs"></app-breadcrum>
</div>
<div [class.px-4]="isStandalone" [class.sm:px-6]="isStandalone" [class.lg:px-8]="isStandalone">
<!-- Default View with no vehicle added -->
<div
  *ngIf="myGarage.length === 0 && !isAnyFilterSelected"
  [formGroup]="vehicleForm"
  class="relative max-md:p-4 "
>
  <div
  *ngIf="myGarage.length > 0 && isMobile"
    class="text-[#000] text-[24px] font-bold leading-[32px]"
  >
    My Garage
  </div>

  <!-- Banner Box -->
  <div
    class="BannerBox flex p-4 sm:p-6 md:p-8 flex-col items-start gap-4 sm:gap-6 rounded-[16px] border border-[#307FE1] bg-[rgba(245,249,254,0.4)] mt-4 sm:mt-[26px] relative w-full max-w-full md:max-w-[950px] md:w-full"
  >
    <div class="relative items-center justify-between">
      <h2
        class="BannerText text-[#0A0A5F] text-[18px] font-bold leading-[24px]"
      >
        Start by adding vehicles in your garage
      </h2>
    </div>

    <!-- Reactive Form Fields -->
    <div class="FormGrid grid grid-cols-1 md:grid-cols-3 gap-4 mt-2 sm:mt-4">
      <form
        [formGroup]="vehicleForm"
        (ngSubmit)="confirmAdd()"
        class="grid grid-cols-1 md:grid-cols-3 gap-4 col-span-3"
      >
        <!-- Registration Number -->
        <div class="flex flex-col items-start self-stretch">
          <label class="text-sm font-medium mb-1">Registration No.</label>
          <input
            type="text"
            class="border rounded-[8px] px-4 py-2 text-sm w-full"
            placeholder="E.g. MH14GH9900"
            formControlName="reg_no"
            pattern="[A-Za-z0-9]*"
            minlength="10"
            maxlength="10"
            (input)="preventLeadingSpace($event)"
            (keydown)="onRegistrationNoKeydown($event)"
          />
        
        <div *ngIf="vehicleForm.get('reg_no')?.invalid && (vehicleForm.get('reg_no')?.dirty || vehicleForm.get('reg_no')?.touched)" class="text-red-500 text-sm mt-1 max-md:text-xs">
            <div *ngIf="vehicleForm.get('reg_no')?.errors?.['pattern']">Invalid registration number (only letters and numbers allowed)</div>
            <div *ngIf="vehicleForm.get('reg_no')?.errors?.['minlength']">Registration number must be exactly 10 characters long.</div>
            <div *ngIf="vehicleForm.get('reg_no')?.errors?.['leadingSpace']">Registration number cannot start with a space.</div>
            <div *ngIf="vehicleForm.get('reg_no')?.errors?.['containsSpace']">Registration number cannot contain spaces.</div>
          </div>
          <div *ngIf="noVehicleFound" class="flex items-center gap-2 text-amber-600 text-sm mt-1 max-md:text-xs">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              class="flex-shrink-0"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="2"
                fill="none"
              />
              <path
                d="M12 8V12M12 16H12.01"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>for this registration number no vehicle found</span>
          </div>

        </div>

        <!-- Brand -->
        <div class="flex flex-col items-start self-stretch">
          <label class="text-sm font-medium mb-1">Brand</label>
          <select
            class="border rounded-[8px] px-4 py-2 text-sm w-full"
            formControlName="make"
            (change)="onBrandSelect($event)"
            [disabled]="isRegistrationNoEntered"
          >
            <option value="" class="text-gray-200">Select Brand</option>
            <option *ngFor="let b of brands" [value]="b.brand_name">
              {{ b?.brand_name }}
            </option>
          </select>
        </div>

        <!-- Model -->
        <div class="flex flex-col items-start self-stretch">
          <label class="text-sm font-medium mb-1">Model</label>
          <select
            class="border rounded-[8px] px-4 py-2 text-sm w-full text-base leading-6"
            formControlName="model"
            (change)="onModelSelect($event)"
            [disabled]="isRegistrationNoEntered"
          >
            <option value="" class="text-[#777]" disabled>Select Model</option>
            <option *ngFor="let model of modelList" [value]="model.model_name">
              {{ model?.model_name }}
            </option>
          </select>
        </div>

        <!-- Year -->
        <div class="flex flex-col items-start self-stretch">
          <label class="text-sm font-medium mb-1">Year of Manufacture</label>

          <select
            class="border rounded-[8px] px-4 py-2 text-sm w-full"
            formControlName="year_of_manufacturing"
            (change)="getYearList($event)"
            [disabled]="isRegistrationNoEntered"
          >
            <option value="" disabled>Select Year</option>
            <!-- <option *ngFor="let v of yearList" [value]="v.year_of_manufacturing">{{ v.year_of_manufacturing }}</option> -->
            <option *ngFor="let v of yearList" [value]="v">{{ v }}</option>
          </select>
        </div>

        <!-- Variant -->
        <div class="flex flex-col items-start self-stretch">
          <label class="text-sm font-medium mb-1">Variant</label>
          <select
            class="border rounded-[8px] px-4 py-2 text-sm w-full"
            formControlName="variant"
            (click)="onVariantSelect($event)"
            [disabled]="isRegistrationNoEntered"
          >
            <option value="" class="text-[#777]" disabled>
              Select Variant
            </option>
            <option *ngFor="let v of varientList" [value]="v.variant_name">
              {{ v.variant_name }}
              {{ v.vehicle_variant }}
            </option>
          </select>
        </div>

        <!-- Submit Button -->
        <div class="flex items-end self-stretch">
          <button
            type="submit"
            class="bg-[#0A0A5F] text-white rounded-[8px] px-4 py-2 text-sm w-full disabled:bg-[#8A93D8] disabled:cursor-not-allowed"
            [disabled]="!isFormValid()"
          >
            Add Vehicle
          </button>
        </div>
      </form>
    </div>

    <div class="absolute top-0 right-0 ml-[-17px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="56"
        viewBox="0 0 80 56"
        fill="none"
      >
        <g opacity="0.6" clip-path="url(#clip0_2215_42819)">
          <path
            opacity="0.6"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M44.2859 -25.668H35.7154C33.4797 -25.668 31.6673 -23.8556 31.6673 -21.6199C31.6673 -19.7498 30.3772 -18.1465 28.6064 -17.5452C27.1392 -17.047 25.7152 -16.4552 24.3415 -15.777C22.6639 -14.9486 20.617 -15.1701 19.294 -16.4931C17.7125 -18.0746 15.1484 -18.0746 13.5669 -16.4931L7.50884 -10.4351C5.92736 -8.85357 5.92736 -6.28948 7.50884 -4.708C8.83184 -3.38499 9.05333 -1.33808 8.225 0.339575C7.54676 1.71324 6.95498 3.13722 6.45675 4.60441C5.85543 6.37522 4.25218 7.66536 2.38207 7.66536C0.146374 7.66536 -1.66602 9.47775 -1.66602 11.7134V20.2839C-1.66602 22.5196 0.146373 24.332 2.38207 24.332C4.25218 24.332 5.85543 25.6222 6.45675 27.393C6.95498 28.8602 7.54678 30.2842 8.22502 31.6579C9.05336 33.3355 8.83187 35.3824 7.50887 36.7054C5.9274 38.2869 5.9274 40.851 7.50888 42.4325L10.5379 45.4615L28.2155 27.7838C25.1995 24.7677 23.334 20.6011 23.334 15.9987C23.334 6.79395 30.7959 -0.667969 40.0006 -0.667969C44.603 -0.667969 48.7697 1.19753 51.7858 4.21362L69.4634 -13.4641L66.4344 -16.4931C64.853 -18.0746 62.2889 -18.0746 60.7074 -16.4931C59.3844 -15.1701 57.3375 -14.9486 55.6598 -15.7769C54.2861 -16.4552 52.8621 -17.047 51.3949 -17.5452C49.6241 -18.1465 48.334 -19.7498 48.334 -21.6199C48.334 -23.8556 46.5216 -25.668 44.2859 -25.668Z"
            fill="#C0D8F6"
          />
          <path
            opacity="0.4"
            d="M72.4912 -4.70481C74.0727 -6.2863 74.0727 -8.8504 72.4912 -10.4319L69.4622 -13.4609L51.7845 4.21677C54.8006 7.23284 56.6661 11.3995 56.6661 16.0019C56.6661 25.2066 49.2041 32.6685 39.9994 32.6685C35.397 32.6685 31.2304 30.803 28.2143 27.787L10.5366 45.4646L13.5657 48.4937C15.1472 50.0752 17.7113 50.0752 19.2927 48.4937C20.6158 47.1707 22.6627 46.9492 24.3403 47.7775C25.714 48.4558 27.1379 49.0475 28.6051 49.5457C30.3759 50.1471 31.6661 51.7503 31.6661 53.6204C31.6661 55.8561 33.4785 57.6685 35.7141 57.6685H44.2846C46.5203 57.6685 48.3327 55.8561 48.3327 53.6204C48.3327 51.7503 49.6229 50.1471 51.3937 49.5457C52.8609 49.0475 54.2849 48.4557 55.6585 47.7775C57.3362 46.9492 59.3831 47.1707 60.7061 48.4937C62.2876 50.0751 64.8517 50.0751 66.4331 48.4937L72.4912 42.4356C74.0727 40.8541 74.0727 38.29 72.4912 36.7085C71.1682 35.3855 70.9467 33.3386 71.775 31.661C72.4533 30.2873 73.0451 28.8633 73.5433 27.3961C74.1446 25.6253 75.7479 24.3352 77.618 24.3352C79.8537 24.3352 81.6661 22.5228 81.6661 20.2871V11.7166C81.6661 9.4809 79.8537 7.66852 77.618 7.66852C75.7479 7.66852 74.1446 6.37837 73.5433 4.60757C73.0451 3.14039 72.4533 1.71642 71.7751 0.342776C70.9467 -1.33489 71.1682 -3.3818 72.4912 -4.70481Z"
            fill="#307FE1"
          />
        </g>
        <defs>
          <clipPath id="clip0_2215_42819">
            <rect
              width="80"
              height="80"
              fill="white"
              transform="translate(0 -24)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
</div>

<!-- view when u have already added vehical -->

<div
  class="Garage w-full max-w-full lg:max-w-[1044px]"
  *ngIf="myGarage.length > 0 || isAnyFilterSelected"
>
  <div
    class="Flex flex flex-row justify-between items-center sm:mb-4 gap-2"
  >
    <h2
      class="Heading text-black text-[18px] font-bold leading-[24px] lg:text-[24px] lg:leading-[32px]"
    >
      My Garage
      <span
        class="text-[#777] text-[14px] font-medium leading-[20px] lg:text-[18px] lg:leading-[24px]"
        >- {{ totalResult }} vehicles</span
      >
    </h2>

    <!-- add vehicle div -->
    <div
      class="AdVehButton flex items-center gap-2 px-4 py-2 rounded-lg border border-[#0A0A5F] cursor-pointer hover:bg-blue-50 transition duration-150 max-md:px-3 max-md:py-3 max-md:rounded-[8px] max-md:border max-md:border-[#0A0A5F] max-md:justify-center max-md:items-center max-md:gap-1 max-md:self-stretch max-md:mt-[0px] max-md:mr-[19px] max-md:mb-[7px] max-md:ml-[0px] max-md:w-[105px] max-md:h-[37px] max-md:mt-[8px] lg:mr-[38px]"
      (click)="openAddVehiclePanel()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        class="PlusSvg"
      >
        <path
          d="M12 12H17M12 12H7M12 12V7M12 12V17"
          stroke="#0A0A5F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span
        class="Text text-[#0A0A5F] font-bold text-sm sm:text-base leading-5 whitespace-nowrap"
      >
        Add Vehicle
      </span>
    </div>
  </div>

  <!-- Sort button & search input -->
  <div
    class="SortButton flex flex-row-reverse sm:flex-row justify-between gap-2 lg:mr-[38px]"
  >
    <!-- Background Overlay for Desktop -->
    <div
      *ngIf="showDropdown"
      class="fixed inset-0 bg-black bg-opacity-50 z-40 hidden md:block"
      (click)="showDropdown = false"
    ></div>

    <!-- Sort button -->
    <div class="relative" #dropdownRef>
      <!-- Trigger Button -->
      <button
        (click)="toggleDropdown()"
        [ngClass]="{
          'border-blue-500': showDropdown,
          'border-[#D4D4D4]': !showDropdown
        }"
        class="flex items-center h-8 px-3 py-1 gap-1 rounded-lg text-sm font-medium text-black bg-white focus:outline-none border max-md:rounded-[8px] max-md:border max-md:border-[#D4D4D4] max-md:bg-white max-md:flex max-md:py-[4px] max-md:pr-[8px] max-md:pl-[12px] max-md:justify-center max-md:items-center max-md:gap-[4px] max-md:self-stretch max-md:mr-[10px] whitespace-nowrap"
      >
        Sort By

        <svg
          class="ml-1"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M2 16L6 16M2 10L10 10M2 4L14 4"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </button>

      <!-- Dropdown Menu desktop -->
      <div *ngIf="showDropdown" class="bg-opacity-100 hidden md:block">
        <!-- Dropdown Menu -->
        <div
          *ngIf="showDropdown"
          class="absolute z-10 mt-1 w-48 bg-white divide-y divide-gray-200 rounded shadow z-50 hidden sm:block"
        >
          <div
            class="px-4 py-2 cursor-pointer text-sm"
            (click)="selectOption('recent')"
          >
            Recently Added
          </div>
          <div
            class="px-4 py-2 cursor-pointer text-sm"
            (click)="selectOption('old')"
          >
            Old to New
          </div>
          <div
            class="px-4 py-2 cursor-pointer text-sm"
            (click)="selectOption('new')"
          >
            New to Old
          </div>

          <div
            class="px-4 py-2 cursor-pointer text-sm"
            (click)="selectOption('two_wheeler')"
          >
            Two - Wheeler
          </div>
          <div
            class="px-4 py-2 cursor-pointer text-sm"
            (click)="selectOption('four_wheeler')"
          >
            Four - Wheeler
          </div>
        </div>
      </div>
      <!-- Dropdown Menu for mobile -->
      <div
        *ngIf="showDropdown"
        class="w-full bg-white rounded-t-lg shadow-md sm:hidden fixed bottom-0 left-0 right-0 h-auto max-md:fixed max-md:left-0 max-md:right-0 max-md:w-full  max-md:rounded-t-xl max-md:slide-up bg-opacity-100 z-40"
      >
        <!-- Header -->
        <div class="flex justify-between items-center px-4 py-3 border-b">
          <h2 class="text-lg font-bold text-[#0A0A5F] whitespace-nowrap">Sort by</h2>
          <button
            class="text-[#0A0A5F] text-xl font-bold"
            (click)="showDropdown = false"
          >
            &times;
          </button>
        </div>

        <!-- Options -->
        <div class="divide-y divide-gray-300">
          <label
            class="flex items-center px-4 py-3"
            (click)="selectOption('recent')"
          >
            <input
              type="radio"
              name="sort"
              class="mr-3 w-5 h-5 border-gray-400"
              [checked]="sortBy === 'recently_added'"
              (click)="$event.stopPropagation()"
            />
            <span class="text-base text-black">Recently Added</span>
          </label>
          <label
            class="flex items-center px-4 py-3"
            (click)="selectOption('old')"
          >
            <input
              type="radio"
              name="sort"
              class="mr-3 w-5 h-5 border-gray-400"
              [checked]="sortBy === 'old_to_new'"
              (click)="$event.stopPropagation()"
            />
            <span class="text-base text-black">Old to New</span>
          </label>
          <label
            class="flex items-center px-4 py-3"
            (click)="selectOption('new')"
          >
            <input
              type="radio"
              name="sort"
              class="mr-3 w-5 h-5 border-gray-400"
              [checked]="sortBy === 'new_to_old'"
              (click)="$event.stopPropagation()"
            />
            <span class="text-base text-black">New to Old</span>
          </label>
          <label
            class="flex items-center px-4 py-3"
            (click)="selectOption('two_wheeler')"
          >
            <input
              type="radio"
              name="sort"
              class="mr-3 w-5 h-5 border-gray-400"
              [checked]="sortBy === 'two_wheeler'"
              (click)="$event.stopPropagation()"
            />
            <span class="text-base text-black">Two - wheeler</span>
          </label>
          <label
            class="flex items-center px-4 py-3"
            (click)="selectOption('four_wheeler')"
          >
            <input
              type="radio"
              name="sort"
              class="mr-3 w-5 h-5 border-gray-400"
              [checked]="sortBy === 'four_wheeler'"
              (click)="$event.stopPropagation()"
            />
            <span class="text-base text-black">Four - wheeler</span>
          </label>
        </div>
      </div>
    </div>

    <!-- Search field -->
    <div
      class="flex w-[232px] max-md:w-full h-8 p-2 justify-between items-center rounded-[6px] border border-[#D4D4D4] max-md:ml-[11px]"
    >
      <input
        [(ngModel)]="searchText"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onSearchChange($event)"
        (input)="triggerSearch()"
        placeholder="Search added vehicles"
        class="text-[#777] text-sm font-medium leading-5 outline-none focus:ring-0 focus:border-transparent"
      />
      <svg
        (click)="triggerSearch()"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        class="cursor-pointer"
      >
        <path
          d="M13.8807 13.8807C16.4842 11.2772 16.4842 7.05612 13.8807 4.45262C11.2772 1.84913 7.05612 1.84913 4.45262 4.45262C1.84913 7.05612 1.84913 11.2772 4.45262 13.8807C7.05612 16.4842 11.2772 16.4842 13.8807 13.8807ZM13.8807 13.8807L17.5 17.5"
          stroke="#777777"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>

  <!--  vehicle card and -edit & delete pop up -->

  <div
    class="Grid grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2 mt-4 items-stretch"
    *ngIf="myGarage.length > 0"
  >
  <div
  #cardWrapper
  *ngFor="let v of myGarage; let i = index"
  class="Card bg-white rounded-xl shadow-sm p-1 flex flex-col h-full"
>
  <!-- vehicle card -->
  <div
    class="VehicleCard relative flex rounded-lg bg-[#F2F2F2] 
           lg:p-[27px] lg:h-[174px] lg:w-[284px]
           p-4 w-full h-[170px] overflow-hidden"
  >
    <!-- three-dot menu -->
    <div class="absolute top-2 right-2 cursor-pointer">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        (click)="edittoggle(i)"
      >
        <path
          d="M12 13C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12C13 12.55 12.55 13 12 13Z"
          stroke="black"
          stroke-width="2"
        />
        <path
          d="M12 7C11.45 7 11 6.55 11 6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6C13 6.55 12.55 7 12 7Z"
          stroke="black"
          stroke-width="2"
        />
        <path
          d="M12 19C11.45 19 11 18.55 11 18C11 17.45 11.45 17 12 17C12.55 17 13 17.45 13 18C13 18.55 12.55 19 12 19Z"
          stroke="black"
          stroke-width="2"
        />
      </svg>
    </div>

    <!-- edit/delete dropdown -->
    <div
      #editMenu
      *ngIf="selectedEditIndex === i"
      class="absolute z-50 right-2 w-[101px] bg-white divide-y divide-gray-200 rounded shadow hidden md:block"
    >
      <div
        class="flex justify-between items-center px-4 py-3 border-b md:hidden"
      >
        <h2 class="text-lg font-bold text-[#0A0A5F]">Action</h2>
        <button
          class="text-[#0A0A5F] text-xl font-bold"
          (click)="closeActionHeader()"
        >
          &times;
        </button>
      </div>

      <div
        class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
        (click)="editvehicle('edit', i)"
      >
        Edit
      </div>
      <div
        class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
        (click)="editvehicle('delete', i)"
      >
        Delete
      </div>
    </div>

    <!-- vehicle image (never overflows) -->
    <div class="flex justify-center items-center w-full h-full overflow-hidden">
      <img
        [src]="v.image_path || '../../assets/Vehical_images/vehical_1.png'"
        alt="Vehicle"
        class="object-contain w-full h-full max-w-full max-h-full rounded-md"
      />
    </div>
  </div>

  <!-- reg no -->
  <div
    *ngIf="v.reg_no"
    class="inline-flex items-center bg-[#C0D8F666] mt-[10px] p-2 rounded gap-2 h-[26px]"
  >
    <img
      src="../../assets/Vehical_images/reg icon 1.png"
      alt="icon"
      class="w-5 h-5"
    />
    <span
      class="px-1 py-0.5 rounded text-black text-[14px] font-bold leading-[20px]"
    >
      {{ v.reg_no }}
    </span>
  </div>

  <!-- make & model -->
  <div class="flex-1 flex flex-col min-h-0 mt-2">
    <h3 class="text-black text-[16px] font-bold leading-[24px] line-clamp-2">
      {{ v.make }}
    </h3>

    <p class="text-sm text-gray-500 line-clamp-2">
      {{ v.make }} • {{ v.model }} • {{ v.year_of_manufacturing }} •
      {{ v.variant }}
    </p>
  </div>

  <!-- view button -->
  <button
    class="Button rounded-[8px] border border-[#0A0A5F] flex p-2 justify-center items-center gap-1 self-stretch w-full mt-auto lg:w-[287px]"
    (click)="gotoProductlist(v)"
  >
    <span
      class="text-[#0A0A5F] text-center font-bold text-[16px] leading-[24px]"
    >
      View Parts
    </span>
  </button>
</div>

  </div>

  <!-- Mobile-only action bottom sheet (single instance for all rows) -->
  <div *ngIf="selectedEditIndex !== null" class="md:hidden">
    <!-- Background overlay -->
    <div
      class="fixed inset-0 bg-black bg-opacity-50 z-[9998] transition-opacity duration-300"
      (click)="selectedEditIndex = null"
    ></div>

    <!-- Bottom sheet -->
    <div
      class="mobile-bottom-sheet fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-2xl z-[9999] max-h-[60vh] overflow-hidden flex flex-col"
    >
      <div class="flex justify-between items-center px-4 py-3 border-b border-gray-200 flex-shrink-0">
        <h2 class="text-lg font-bold text-[#0A0A5F]">Action</h2>
        <button
          class="text-[#0A0A5F] text-2xl font-bold w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors"
          (click)="selectedEditIndex = null"
        >
          &times;
        </button>
      </div>
      <div class="divide-y divide-gray-200 flex-1 overflow-y-auto">
        <div
          class="px-4 py-4 cursor-pointer text-base font-medium text-gray-900 hover:bg-gray-50 active:bg-gray-100 transition-colors"
          (click)="editvehicle('edit', selectedEditIndex!)"
        >
          Edit
        </div>
        <div
          class="px-4 py-4 cursor-pointer text-base font-medium text-red-600 hover:bg-red-50 active:bg-red-100 transition-colors"
          (click)="editvehicle('delete', selectedEditIndex!)"
        >
          Delete
        </div>
      </div>
    </div>
  </div>

  <!-- add/edit vehical popup -->
  <div *ngIf="showPanel && !showConfirmation" class="fixed inset-0 z-[9999]">
    <!-- Backdrop -->
    <div
      class="fixed inset-0 bg-black bg-opacity-50 z-[9998] transition-opacity duration-300"
      (click)="closePanel()"
    ></div>
    
    <!-- Popup Panel -->
    <div
      class="fixed inset-0 z-[9999] flex items-end justify-center max-md:items-end pointer-events-none"
    >
      <div
        class="absolute top-0 right-0 bg-white shadow-lg w-[484px] max-h-screen overflow-y-auto flex flex-col max-md:fixed max-md:top-auto max-md:bottom-0 max-md:left-0 max-md:right-0 max-md:w-full max-md:rounded-t-2xl max-md:mobile-panel-slide-up pointer-events-auto"
        (click)="$event.stopPropagation()"
      >
        <div class="border-b p-4 flex justify-between items-center">
          <h2
            class="text-[#0A0A5F] text-[24px] leading-[32px] font-bold"
          >
            {{
              showConfirmation
                ? "Is this vehicle correct?"
                : isEditing
                ? "Edit Vehicle"
                : "Add Vehicle"
            }}
          </h2>
          <button
            class="text-2xl font-bold text-gray-500 hover:text-gray-700"
            (click)="closePanel()"
          >
            &times;
          </button>
        </div>

        <form
          [formGroup]="vehicleForm"
          class="flex flex-col gap-4 w-full p-[21px]"
        >
          <!-- Registration No -->
          <div class="flex flex-col items-start self-stretch">
            <label class="text-sm font-medium mb-1">Registration No.</label>
            <input
              type="text"
              class="Input border rounded-[8px] px-4 py-2 text-sm w-full"
              pattern="[A-Za-z0-9]*"
              placeholder="E.g. MH14GH9900"
              formControlName="reg_no"
              maxlength="10"
              minlength="10"
              (input)="preventLeadingSpace($event)"
              (keydown)="onRegistrationNoKeydown($event)"
            /> 
            <div *ngIf="vehicleForm.get('reg_no')?.invalid && (vehicleForm.get('reg_no')?.dirty || vehicleForm.get('reg_no')?.touched)" class="text-red-500 text-sm mt-1 max-md:text-xs">
            <div *ngIf="vehicleForm.get('reg_no')?.errors?.['pattern']">Invalid registration number (only letters and numbers allowed)</div>
            <div *ngIf="vehicleForm.get('reg_no')?.errors?.['minlength']">Registration number must be exactly 10 characters long.</div>
            <div *ngIf="vehicleForm.get('reg_no')?.errors?.['leadingSpace']">Registration number cannot start with a space.</div>
            <div *ngIf="vehicleForm.get('reg_no')?.errors?.['containsSpace']">Registration number cannot contain spaces.</div>
          </div>
         
          <div *ngIf="noVehicleFound" class="flex items-center gap-2 text-amber-600 text-sm mt-1 max-md:text-xs">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              class="flex-shrink-0"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="2"
                fill="none"
              />
              <path
                d="M12 8V12M12 16H12.01"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>for this registration number no vehicle found</span>
          </div>

          </div>
          

          <!-- Brand -->
          <div class="flex flex-col items-start self-stretch">
            <label class="text-sm font-medium mb-1">Brand</label>

            <select
              class="Select border rounded-[8px] px-4 py-2 text-sm w-full text-base leading-6"
              formControlName="make"
              (change)="onBrandSelect($event)"
              [disabled]="isRegistrationNoEntered"
            >
              <option value="" class="text-gray-200">Select Brand</option>
              <option *ngFor="let v of brands" [value]="v.brand_name">
                {{ v?.brand_name }}
              </option>
            </select>
            <div *ngIf="vehicleForm.get('make')?.invalid && (vehicleForm.get('make')?.dirty || vehicleForm.get('make')?.touched)" class="text-red-500 text-sm mt-1">
              <div *ngIf="vehicleForm.get('make')?.errors?.['required']">Brand is required.</div>
            </div>
          </div>

          <!-- Model -->
          <div class="flex flex-col items-start self-stretch">
            <label class="text-sm font-medium mb-1">Model</label>

            <select
              class="border rounded-[8px] px-4 py-2 text-sm w-full text-base leading-6"
              formControlName="model"
              (change)="onModelSelect($event)"
              [disabled]="isRegistrationNoEntered"
            >
              <option value="" class="text-[#777]" disabled>
                Select Model
              </option>
              <option *ngFor="let model of modelList" [value]="model.model_name">
                {{ model?.model_name }}
              </option>
            </select>
            <div *ngIf="(vehicleForm.get('model')?.dirty || vehicleForm.get('model')?.touched)" class="text-red-500 text-sm mt-1">
              <div *ngIf="vehicleForm.get('model')?.errors?.['required']">Model is required.</div>
            </div>
          </div>
          <!-- Year of Manufacture -->
          <div class="flex flex-col items-start self-stretch">
            <label class="text-sm font-medium mb-1">Year of Manufacture</label>

            <select
              class="border rounded-[8px] px-4 py-2 text-sm w-full"
              formControlName="year_of_manufacturing"
              (change)="getYearList($event)"
              [disabled]="isRegistrationNoEntered"
            >
              <option value="" disabled>Select Year</option>
              <!-- <option *ngFor="let v of yearList" [value]="v.year_of_manufacturing">{{ v.year_of_manufacturing }}</option> -->
              <option *ngFor="let y of yearList" [value]="y">{{ y }}</option>
            </select>
          </div>

          <!-- Variant -->
          <div class="flex flex-col items-start self-stretch">
            <label class="text-sm font-medium mb-1">Variant</label>
            <select
              class="border rounded-[8px] px-4 py-2 text-sm w-full"
              formControlName="variant"
              (change)="onVariantSelect($event)"
              [disabled]="isRegistrationNoEntered"
            >
              <option value="" class="text-[#777]" disabled>
                Select Variant
              </option>
              <option *ngFor="let v of varientList" [value]="v.variant_name">
                {{ v.variant_name }}
              </option>
            </select>
          </div>
        </form>
        <!-- button div -->
        <div class="border-t px-4 py-3 flex gap-4 bg-white mt-auto max-md:mt-0">
          <button
            class="flex-1 border border-blue-700 text-blue-700 px-4 py-2 rounded-[8px]"
            (click)="closePanel()"
          >
            Cancel
          </button>
          <button
            class="flex-1 text-white px-4 py-2 rounded-[8px] bg-blue-900 disabled:opacity-50 disabled:cursor-not-allowed"
            [disabled]="!isFormValid()"
            (click)="isEditing ? updateVehicle() : onProceed()"
          >
            {{ isEditing ? "save" : "Proceed" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="myGarage.length === 0 && isAnyFilterSelected"
    class="w-full text-center py-8"
  >
    <div class="text-text-caption text-lg">No Data found</div>
  </div>
</div>

<!-- Confirmation Preview -->
<div *ngIf="showConfirmation" class="fixed inset-0 z-[9999]">
  <!-- Backdrop -->
  <div
    class="fixed inset-0 bg-black bg-opacity-50 z-[9998] transition-opacity duration-300"
    (click)="closePanel()"
  ></div>
  
  <!-- Confirmation Panel -->
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center max-md:items-end pointer-events-none"
  >
    <div
      class="absolute top-0 right-0 bg-white shadow-lg w-[484px] max-h-screen overflow-y-auto flex flex-col max-md:fixed max-md:top-auto max-md:bottom-0 max-md:left-0 max-md:right-0 max-md:w-full max-md:max-h-[90vh] max-md:rounded-t-2xl max-md:mobile-panel-slide-up pointer-events-auto"
      (click)="$event.stopPropagation()"
    >
    <div class="border-b p-4 flex justify-between items-center">
      <h2
        class="text-[#0A0A5F] text-[24px] leading-[32px] font-bold"
      >
        Is this vehicle correct ?
      </h2>
      <button
        class="text-2xl font-bold text-gray-500 hover:text-gray-700"
        (click)="closePanel()"
      >
        &times;
      </button>
    </div>

    <!-- vehicle imgage  -->
    <div class="flex justify-center">
      <img
        src="../../assets/Vehical_images/vehical_1.png"
        alt="Vehicle"
        class="w-[200px] h-[200px] object-contain rounded-md"
      />
    </div>

    <p
      class="text-[#0A0A5F] text-center text-[20px] font-bold leading-[28px]"
    >
      <span>{{ previewData?.VEHICLE_MAKE_s }},</span>
      <span>{{ previewData?.YEAR_OF_MANUFACTURE_s }},</span>
      <span>{{ previewData?.VARIANT_s }}</span>
    </p>

    <div class="grid grid-cols-3 gap-4 text-sm w-full p-8">
      <div>
        <span class="text-gray-500">Brand</span><br /><strong>{{
          previewData?.VEHICLE_MAKE_s
        }}</strong>
      </div>
      <div>
        <span class="text-gray-500">Fule type </span><br /><strong> </strong>
      </div>

      <div>
        <span class="text-gray-500"> Engine Litre </span><br /><strong></strong>
      </div>
      <div>
        <span class="text-gray-500">Power </span><br />
        <strong>{{ previewData?.max_power_kw }}</strong>
      </div>
      <div>
        <span class="text-gray-500"> Brake Type </span><br /><strong></strong>
      </div>
      <div>
        <span class="text-gray-500"> Transmission Type </span
        ><br /><strong></strong>
      </div>
    </div>

    <div class="border-t px-4 py-3 flex gap-4 bg-white mt-auto">
      <button
        class="flex-1 border border-blue-700 text-blue-700 rounded h-[43px] max-md:h-auto"
        (click)="closePanel()"
      >
        {{ showConfirmation ? "No" : "Cancel" }}
      </button>
      <button
        class="flex-1 border border-blue-700 text-white rounded h-[43px] bg-blue-900 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="showConfirmation ? confirmAdd() : savePanel()"
      >
        {{ showConfirmation ? "Yes" : isEditing ? "Save" : "Proceed" }}
      </button>
    </div>
    </div>
  </div>
</div>
<!-- Pagination -->
<!-- <div class="w-full flex justify-center py-16 relative"  *ngIf="myGarage.length > 0">

    <app-pagination [currentPage]="currentPageValue" [totalPages]="totalPagesValue" [isVisible]="showPagination"
        [totalPages]="totalPagesValue" (pageChange)="handlePageChange($event)">
    </app-pagination>
</div> -->

</div>